import axios from 'axios'

export const http = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
    timeout: 15000,
    withCredentials: true,
    withXSRFToken: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
})

import { toast } from 'sonner'
import { useSessionStore } from '../../store/auth/auth.store'

// Interceptor para inyectar X-Sucursal-Id
http.interceptors.request.use((config) => {
    const activeBranchId = useSessionStore.getState().activeBranchId
    if (activeBranchId) {
        config.headers['X-Sucursal-Id'] = activeBranchId.toString()
    }
    return config
})

http.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 403) {
            const message = error.response.data?.message || 'No tienes permiso para acceder a este recurso.'
            
            // Si es un error relacionado a la sucursal o permisos generales
            if (message.toLowerCase().includes('sucursal')) {
                useSessionStore.getState().setRevoked(message)
                useSessionStore.getState().setActiveBranchId(null)
            } else {
                toast.error(message)
            }
        }
        return Promise.reject(error)
    }
)
